import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Scale } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useFetch } from "../../lib/hooks";
import { useI18n } from "../../lib/i18n";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { StatusBadge } from "./Ui";

const ORDER = ["knowledge", "skill", "physical", "attitude"];

function CategoryCard({ cat, onSaved }) {
  const { t } = useI18n();
  const { can } = useAuth();
  const [w, setW] = useState({});
  useEffect(() => setW(Object.fromEntries(cat.components.map((c) => [c.name, c.weight]))), [cat]);
  const total = Object.values(w).reduce((a, b) => a + (Number(b) || 0), 0);
  const ok = Math.abs(total - 100) < 0.01;
  const save = async () => {
    try { const { data } = await api.put("/modules/weights", { category: cat.category, weights: Object.fromEntries(Object.entries(w).map(([k, v]) => [k, Number(v)])) }); toast.success(`${data.updated} modul diperbarui`); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="surface p-4 space-y-3" data-testid={`weights-${cat.category}`}>
      <div className="flex items-center justify-between"><h3 className="section-title">{t(`cat.${cat.category}`)}</h3><span className="text-xs text-slate-500">{cat.modules} modul</span></div>
      <table className="w-full text-sm"><thead><tr className="table-head"><th className="p-2 text-left">Komponen</th><th className="p-2 text-left">Tipe</th><th className="p-2 text-right w-28">Bobot %</th></tr></thead>
        <tbody>{cat.components.map((c) => <tr key={c.name} className="border-t"><td className="p-2 font-medium">{c.name}{c.mixed && <span className="ml-1 text-[10px] text-amber-600" title="Bobot berbeda antar modul">(campuran)</span>}</td><td className="p-2"><StatusBadge value={c.type} /></td>
          <td className="p-2"><Input data-testid={`weight-${cat.category}-${c.name.replace(/\s+/g, "-").toLowerCase()}`} type="number" min={0} max={100} className="h-8 text-right" value={w[c.name] ?? ""} onChange={(e) => setW({ ...w, [c.name]: e.target.value })} disabled={!can("lms:write")} /></td></tr>)}</tbody>
        <tfoot><tr className="border-t font-bold"><td className="p-2" colSpan={2}>Total</td><td className={`p-2 text-right ${ok ? "text-emerald-700" : "text-red-600"}`} data-testid={`weights-total-${cat.category}`}>{total}%</td></tr></tfoot></table>
      {can("lms:write") && <div className="flex justify-end"><Button data-testid={`weights-save-${cat.category}`} size="sm" className="bg-[color:var(--brand-blue)] hover:bg-[color:var(--brand-blue-dark)]" disabled={!ok} onClick={save}><Scale className="h-4 w-4 mr-1" />Terapkan ke {cat.modules} modul</Button></div>}
    </div>
  );
}

export function GlobalWeights() {
  const { data, reload } = useFetch("/modules/weights");
  const cats = (data || []).sort((a, b) => ORDER.indexOf(a.category) - ORDER.indexOf(b.category));
  return (
    <div className="space-y-3">
      <p className="text-xs text-slate-500">Ubah bobot per kategori — diterapkan ke semua modul dengan nama komponen yang sama di seluruh kelas. Total tiap kategori harus 100%.</p>
      <div className="grid gap-4 lg:grid-cols-2">{cats.map((c) => <CategoryCard key={c.category} cat={c} onSaved={reload} />)}</div>
    </div>
  );
}
